import { useSelector } from 'react-redux'
import { InputLabel, Select, MenuItem, FormHelperText } from '@mui/material'
import { IRootState } from '../../../../redux/types'
import { useTranslation } from 'react-i18next'

function ResourcetypeSelect({ value, handleInputChange }: any) {
  const { t } = useTranslation(['global'])

  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleChange = (event: any) => {
    const resourcetypeId: number = event.target.value
    handleInputChange('resourcetypeId', resourcetypeId)
  }

  return (
    <>
      <InputLabel shrink={true} id="resourcetype-label">
        {t('type')}*
      </InputLabel>
      <Select
        value={value}
        labelId="resourcetype-label"
        id="brands-select-outlined"
        fullWidth
        label={t('type')}
        onChange={event => handleChange(event)}
      >
        {resourcetypes.map((resourcetype: any) => (
          <MenuItem key={resourcetype.id} value={resourcetype.id}>
            {resourcetype.name}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={errorForm.resourcetypeId}>{msgForm.resourcetypeId}</FormHelperText>
    </>
  )
}

export default ResourcetypeSelect
